import type { DocMigration } from "../docMigration";

// eslint-disable-next-line @typescript-eslint/naming-convention
const migration_0_0_357: DocMigration = {
  maxSchemaVersion: "0.0.357",
  description: "Provide default global parameter scope type",
  apply(json: any) {
    if (!json.contentTemplates) {
      json.contentTemplates = {};
    }

    if (!json.planSetTemplates) {
      json.planSetTemplates = {};
    }

    for (const template of Object.values(json.contentTemplates) as any[]) {
      template.globalParameterScopeType = template.globalParameterScopeType ?? "MASTER_PLAN";
    }

    for (const template of Object.values(json.planSetTemplates) as any[]) {
      template.globalParameterScopeType = template.globalParameterScopeType ?? "MASTER_PLAN";
    }

    return json;
  },
};

export default migration_0_0_357;
